export const DEFAULT_PDF_PAGE_SLUG = "documents";

const RESERVED_PDF_PAGE_SLUGS = new Set([
  "admin",
  "about",
  "contact",
  "gallery",
  "reviews",
]);

export const normalizePdfPageSlug = (value) => {
  const raw = typeof value === "string" ? value.trim().toLowerCase() : "";
  const withoutSlashes = raw.replace(/^\/+|\/+$/g, "");
  const slug = withoutSlashes
    .replace(/[^a-z0-9-]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/(^-|-$)/g, "");

  if (!slug || RESERVED_PDF_PAGE_SLUGS.has(slug)) {
    return DEFAULT_PDF_PAGE_SLUG;
  }

  return slug;
};

export const toPdfPagePath = (slugValue) =>
  `/${normalizePdfPageSlug(slugValue)}`;
